export function getRelayEnvironment<TEnvironment = Window['GLOBAL_RELAY_ENV']>(
	relayEnvironment?: TEnvironment,
): TEnvironment | undefined {
	if (relayEnvironment) return relayEnvironment;
	if (!('GLOBAL_RELAY_ENV' in window)) return undefined;

	return window['GLOBAL_RELAY_ENV'] as TEnvironment | undefined;
}
